import { Component } from 'react';

import './LargeTextTooltip.css';
import { Tooltip } from 'react-tooltip';

class LargeTextTooltip extends Component {
  // Check if text is truncated by comparing scrollWidth with clientWidth
  isTextTruncated = () => {
    const { idToOverflow } = this.props;
    const element = document.querySelector('#' + idToOverflow);
    if (!element) return false;
    return element.scrollWidth > element.clientWidth;
  };

  render() {
    const { id } = this.props;

    // Always render the Tooltip, but only show it if text is truncated
    return (
      <Tooltip
        id={id}
        place="top"
        effect="solid"
        afterShow={() => {
          // Hide tooltip if text is not truncated
          if (!this.isTextTruncated()) {
            const tooltipElement = document.querySelector(
              `[id="${id}"].react-tooltip`,
            );
            if (tooltipElement) {
              tooltipElement.style.opacity = '0';
              tooltipElement.style.visibility = 'hidden';
            }
          }
        }}
      />
    );
  }
}

export default LargeTextTooltip;
